import React from "react"
import { Check, ChevronDown } from "lucide-react"

import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
} from "src/components/ui/dropdown-menu"

// A compact chooser for which provider dispatches a channel, shown only when the
// org has 2+ enabled providers for it. `value` is the currently selected key;
// `onChange(key)` is called when the user picks a different one. Render this next
// to the send/call control — it does not trigger the action itself.
export function ProviderPicker({ providers, value, onChange, label = "Provider" }) {
  if (!providers || providers.length < 2) return null

  const selected = providers.find((p) => p.key === value)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          title={`${label}: ${selected?.name || "Choose"}`}
          className="inline-flex items-center gap-1 rounded-lg border border-slate-200 px-2 py-1 text-xs font-medium text-slate-600 hover:border-slate-300 hover:bg-slate-50"
        >
          {selected?.name || "Choose"}
          <ChevronDown className="h-3 w-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40">
        <DropdownMenuLabel>{label}</DropdownMenuLabel>
        <DropdownMenuRadioGroup value={value || ""} onValueChange={onChange}>
          {providers.map((p) => (
            <DropdownMenuRadioItem key={p.key} value={p.key} className="text-xs">
              <span className="flex-1">{p.name}</span>
              {p.key === value && <Check className="h-3.5 w-3.5" />}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
